import { NavLink } from 'react-router-dom';
import { GoCommentDiscussion } from 'react-icons/go';
import { ImStatsBars } from 'react-icons/im';

const menus = [
  {
    label: 'Threads',
    to: '/',
    icon: GoCommentDiscussion,
  },
  {
    label: 'Leaderboards',
    to: '/leaderboards',
    icon: ImStatsBars,
  }];

const Sidebar = () => (
  <nav className="font-medium text-xs tracking-wide bg-white sticky top-[87px] custom-min-height">
    <div className="pt-6 pl-6 xl:pt-[40px] xl:pl-[40px] pb-2 text-[#808080]">MENU</div>
    <ul className="flex flex-col">
      {menus.map((menu) => (
        <li key={menu.label}>
          <NavLink
            to={menu.to}
            style={{ display: 'block', paddingBlock: '16px', position: 'relative' }}
            className={({ isActive }) => (isActive ? 'text-[#F48023] bg-[#FCF4EC] border-l-4 border-[#F48023] pl-5 xl:pl-[36px]' : 'text-black pl-6 xl:pl-[40px]')}
          >
            <span className="font-bold text-sm tracking-wider">
              {menu.label}
            </span>
          </NavLink>
        </li>
      ))}

    </ul>

  </nav>
);

export { menus };

export default Sidebar;
